import { render, staticRenderFns } from "./ScoreSetStat.vue?vue&type=template&id=dbd1e7b6"
import script from "./ScoreSetStat.vue?vue&type=script&lang=js"
export * from "./ScoreSetStat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports